import { createElement } from "react";
import { useCaseMapping } from "./use-case-mapping";
import { cn } from "./classes";

/*
 * dynamicUseCase function
 */
export const dynamicUseCase = (useCaseName: string, className?: string) => {
  if (useCaseMapping[useCaseName]) return createElement(useCaseMapping[useCaseName]?.icon, { className: cn("size-4 shrink-0", className) });
  return null;
};
